<template>
    <div class="contact-us full-screen">
        <!-- content -->
        <div class="wrapper wrapper-full-page section content">
            <div>
                <div class="container mt-5">
                    <b-navbar style="background-color:#fff" class="text-capitalize">
                        <b-navbar-brand href="#">
                            <img src="@/assets/img/MUIC_Logo.png" alt="Kitten">
                        </b-navbar-brand>
                        <b-navbar-nav class="ml-auto">
                            <drop-down class="nav-item"
                                :title="$keycloak.fullName"
                                title-classes="nav-link"
                                icon="fa fa-user-circle-o"
                            >
                                <a class="dropdown-item" :href="$keycloak.createLogoutUrl()"><i class="fa fa-sign-out"></i>Log out</a>
                            </drop-down>
                        </b-navbar-nav>
                    </b-navbar>
                    <div class="row mb-3">
                        <div class="col-md-8 offset-md-2 text-center font-weight-bold">
                            <h4 class="mt-5 mb-0 text-danger">You don't have permission for</h4>
                            <h4 class="mt-2 mb-3"><mark class="bg-danger text-white"><i class="fa fa-ban mr-1" aria-hidden="true"></i>{{ ChkText }} page</mark> </h4>
                            <hr>
                            <h6 class="mt-1 text-muted">
                              Pleace contact
                            </h6>
                            <h6 class="mt-1 text-muted">
                              staff Information Technology Section
                            </h6>
                            <h6 class="mt-1 text-muted">
                              <i class="fa fa-phone-square" aria-hidden="true"></i> Tel. +66 (0) 2700 5000 Ext. 4205 , 4206 , 4208
                            </h6>
                            <!-- <i class="mr-2 fa fa-weixin" aria-hidden="true"></i>Line @MYMUIC
                            <a class="ml-2" href="https://lin.ee/rMSY9VY"><img src="https://scdn.line-apps.com/n/line_add_friends/btn/en.png" alt="add" height="40" border="0"></a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- content -->
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
  import store from "@/store/index";
    export default {
        computed: {
            ...mapGetters({
                msg: 'getRules'
            }),
        },
        mounted(){
            this.whoAmIcontent()
        },
        props: {
            ChkText: { type: String, default: null },
        },
        methods: {
            whoAmIcontent(){
                if(!this.ChkText){
                    // console.log(this.$store.state.permit.RulesUser.roles.length)
                    // console.log(this.$route.meta.permitC)
                    var count = 0
                    var arr = ['faculty','staff','student']
                    for (let index = 0; index < this.$store.state.permit.RulesUser.roles.length; index++) {
                        // console.log(this.$route.meta.permitC.includes(this.$store.state.permit.RulesUser.roles[index]))
                        if(arr.includes(this.$store.state.permit.RulesUser.roles[index])){
                            count++
                        }
                    }
                    // console.log(count)
                    if(count > 0){
                        this.$router.push("/").catch(err => {})
                    }
                }
            },
        }
    };
</script>
